const getServiceDisplayNames = intl => ({
  // Chronic Disease Management
  cdm_guided: intl.formatMessage({
    defaultMessage: 'Clinician-guided Chronic Disease Management',
  }),
  chronic_disease_management: intl.formatMessage({
    defaultMessage: 'Chronic Disease Management',
  }),

  // Mental Health
  children_mental_health: intl.formatMessage({
    defaultMessage: "Children's Mental Health",
  }),
  couples_counselling: intl.formatMessage({
    defaultMessage: 'Couples Counselling',
  }),
  crisis_support: intl.formatMessage({ defaultMessage: 'Crisis Support' }),
  first_step: intl.formatMessage({ defaultMessage: 'First Step' }),
  icbt: intl.formatMessage({ defaultMessage: 'iCBT' }),
  icbt_coach_assisted: intl.formatMessage({
    defaultMessage: 'iCBT (Coach-assisted)',
  }),
  icbt_self_directed: intl.formatMessage({
    defaultMessage: 'iCBT (Self-directed)',
  }),
  icbt_therapist_led: intl.formatMessage({
    defaultMessage: 'iCBT (Therapist-led)',
  }),
  in_person_counselling: intl.formatMessage({
    defaultMessage: 'In-Person Counselling',
  }),
  individual_counselling: intl.formatMessage({
    defaultMessage: 'Individual Counselling',
  }),
  inmh: intl.formatMessage({ defaultMessage: 'Indigenous Mental Health' }),
  mental_health: intl.formatMessage({ defaultMessage: 'Mental Health' }),
  peer_to_peer: intl.formatMessage({ defaultMessage: 'Peer-To-Peer' }),
  specialized_clinical_services: intl.formatMessage({
    defaultMessage: 'Specialized Clinical Services',
  }),
  substance_use_management: intl.formatMessage({
    defaultMessage: 'Substance Use Management',
  }),

  // Pharmacy
  health_store: intl.formatMessage({ defaultMessage: 'Health Store' }),
  pharmacy: intl.formatMessage({ defaultMessage: 'Pharmacy' }),
  specialty_pharmacy: intl.formatMessage({
    defaultMessage: 'Specialty Pharmacy',
  }),

  // Telemedicine
  medical_second_opinion: intl.formatMessage({
    defaultMessage: 'Medical Second Opinion',
  }),
  mso: intl.formatMessage({ defaultMessage: 'Medical Second Opinion' }),
  telemedicine: intl.formatMessage({ defaultMessage: 'Telemedicine' }),

  // Well-being
  fitness: intl.formatMessage({ defaultMessage: 'Fitness' }),
  resl: intl.formatMessage({ defaultMessage: 'Resources Library' }),
  well: intl.formatMessage({ defaultMessage: 'Well-being' }),

  // Work Health and Life Services
  care: intl.formatMessage({ defaultMessage: 'Care Navigation' }),
  care_nav_premium: intl.formatMessage({
    defaultMessage: 'Care Navigation Premium',
  }),
  career_coaching: intl.formatMessage({
    defaultMessage: 'Career Coaching',
  }),
  clinical_navigation: intl.formatMessage({
    defaultMessage: 'Clinical Navigation',
  }),
  collaborative_care: intl.formatMessage({
    defaultMessage: 'Collaborative Care',
  }),
  ergonomic_assessments: intl.formatMessage({
    defaultMessage: 'Ergonomic Assessments',
  }),
  financial_advisory: intl.formatMessage({
    defaultMessage: 'Financial Advisory',
  }),
  health_coaching: intl.formatMessage({ defaultMessage: 'Health Coaching' }),
  health_plus: intl.formatMessage({ defaultMessage: 'Health+' }),
  hormonal_health: intl.formatMessage({ defaultMessage: 'Hormonal Health' }),
  hormonal_health_sponsored: intl.formatMessage({
    defaultMessage: 'Hormonal Health Sponsored',
  }),
  legal_advisory: intl.formatMessage({ defaultMessage: 'Legal Advisory' }),
  life_transitions: intl.formatMessage({
    defaultMessage: 'Life Transitions',
  }),
  personalized_nutrition: intl.formatMessage({
    defaultMessage: 'Personalized Nutrition',
  }),
  personalized_nutrition_sponsored: intl.formatMessage({
    defaultMessage: 'Sponsored Personalized Nutrition',
  }),
});

export default getServiceDisplayNames;
